import { render, staticRenderFns } from "./FundRichfullDeposit.vue?vue&type=template&id=3be0a28d&"
import script from "./FundRichfullDeposit.vue?vue&type=script&lang=js&"
export * from "./FundRichfullDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports